import BasicData from 'rlink-data-connector/BasicData';
import makeRequest from 'rlink-data-connector/makeRequest';
import httpRequestStream from 'rlink-data-connector/streams/httpRequestStream';
import embedded from 'rlink-data-connector/embedded';
import { arrayOf, string } from 'rlink-shapes';

export default class RecruitingJob extends BasicData {
  static mapGreenhouseEmbedded (job) {
    return embedded(RecruitingJob, job.id, {
      url: job.absolute_url,
      locationName: job.location.name,
      title: job.title,
      departments: job.departments.map(department => department.name),
    });
  }

  static mapLeverEmbedded (job) {
    return embedded(RecruitingJob, job.id, {
      url: job.hostedUrl,
      locationName: job.categories.location,
      title: job.text,
      departments: [job.categories.department],
    });
  }
}

RecruitingJob.typeName = 'recruitingjob';

RecruitingJob.attributes = {
  url: string,
  locationName: string,
  title: string,
  departments: arrayOf(string),
};

export const allGreenhouseJobPostings = makeRequest(RecruitingJob, 'allGreenhouseJobPostings', { emptyValue: [] });
export const allLeverJobPostings = makeRequest(RecruitingJob, 'allLeverJobPostings', { emptyValue: [] });

RecruitingJob.requestStreamProviders = {
  allGreenhouseJobPostings: httpRequestStream({
    method: 'GET',
    url: 'https://api.greenhouse.io/v1/boards/relic/embed/jobs?content=true',
    mapResponse: response => (
      response ? response.jobs.map(r => RecruitingJob.mapGreenhouseEmbedded(r)) : null
    ),
    headers: {
      withCredentials: false,
      responseType: 'json',
    },
  }),
  allLeverJobPostings: httpRequestStream({
    method: 'GET',
    url: 'https://api.lever.co/v0/postings/relic?mode=json',
    mapResponse: response => (
      response ? response.map(r => RecruitingJob.mapLeverEmbedded(r)) : null
    ),
    headers: {
      withCredentials: false,
      responseType: 'json',
    },
  }),
};



// WEBPACK FOOTER //
// ./lib/rlink-recruiting/RecruitingJob.js